export default {
  ORIGINAL: '0',
  NEW: '1'
};
